//@flow
import React from "react";
import { Container } from "flux/utils";
import fluxfix from '../../services/fluxfix';

// $FlowFixMe
import css from "./adverts.module.scss";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faArrowCircleDown } from "@fortawesome/free-solid-svg-icons";
// import Heading from '../heading'
// import placeholder from "../../img/placeholder.png";
// import { AudioSource, SourceType } from "../audioplayer/source";
import Store from "../../services/store";
type Props = {};
type State = {
  Store: Object,
  rotationIndex: number,
};
class Adverts extends React.Component<Props, State> {
  constructor(props: Object) {
    super(props);
    this.state = { rotationIndex: 0, Store: {} };
  }
  static getStores() {
    return [Store];
  }

  static calculateState(prevState) {
    return { Store: Store.getState() };
  }

  rotate() {
    const ads = this.state.Store.get("adverts");
    if(!ads)return
    const r = ads.rotation;
    if(!r)return;
    const nextIndex = (this.state.rotationIndex + 1) % r.length;
    this.setState({ rotationIndex: nextIndex });
  }

  timer: *;
  componentDidMount() {
    this.timer = setInterval(() => this.rotate(), 10000);
  }
  componentWillUnmount(){
    clearInterval(this.timer);
  }

  render() {
    const ads = this.state.Store && this.state.Store.get("adverts");

    if (!ads || !ads.rotation) return null;

    // console.log(ads.campaigns[ads.rotation[0]]);

    const campaign = ads.campaigns[ads.rotation[this.state.rotationIndex]];
    const img = campaign.adverts[0]["artwork_banner_6x1"];
    // console.log(campaign)

    if (!img) return null;

    const cta = campaign.call_to_action_url;
    // const featureImg = meta["NowArtistImage"] && (
    //   <div className={css.featureImg}>
    //     <img src={meta["NowArtistImage"]} alt={meta["NowArtist"]} />
    //   </div>
    // );

    return (
      <div className={css.advert}>
        <a href={cta}>
          <img src={img} alt={cta}/>
        </a>
      </div>
    );
  }
}
export default (Container.create(fluxfix.convert(Adverts)):Object);
